const App = {
  SetBackground: () => {
    $("[setBackground]").each(function () {
      var background = $(this).attr("setBackground");
      $(this).css({
        "background-image": "url(" + background + ")",
        "background-size": "cover",
        "background-position": "center center",
      });
    });
    $("[setBackgroundRepeat]").each(function () {
      var background = $(this).attr("setBackgroundRepeat");
      $(this).css({
        "background-image": "url(" + background + ")",
        "background-repeat": "repeat",
      });
    });
  },
  EqualHeightElement: (el) => {
    let height = 0;
    let thisHeight = 0;
    $(el).each(function () {
      thisHeight = $(this).height();
      if (thisHeight > height) {
        height = thisHeight;
      }
    });
    $(el).height(height);
  },
  ScrollTo: (y) => {
    $("html, body").animate(
      {
        scrollTop: y,
      },
      1000
    );
  },
  Init: () => {
    App.ScrollTo();
    App.SetBackground();
  },
};

function InitSlider() {
  var heroBanner = new Swiper(".hero-banner .swiper-container", {
    speed: 1500,
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },

    // autoplay: {
    //   delay: 7000,
    // },
    navigation: {
      clickable: !0,
      nextEl: ".hero-banner .swiper-next",
      prevEl: ".hero-banner .swiper-prev",
    },
    pagination: {
      el: ".hero-banner .swiper-pagination",
      clickable: !0,
      type: "bullets",
    },
  });
  var bestSellersSlide = new Swiper(
    ".best-sellers .swiper-container",
    {
      speed: 1500,
      slidesPerView: 3,
      spaceBetween: 30,
      autoplay: {
        delay: 7000,
      },
      observer: true,
      observeParents: true,
      navigation: {
        clickable: !0,
        nextEl: ".best-sellers .swiper-next",
        prevEl: ".best-sellers .swiper-prev",
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        576: {
          slidesPerView: 1,
          spaceBetween: 15,
        },
      },
    }
  );
  var ourStoriesSlide = new Swiper(
    ".our-stories .swiper-container",
    {
      speed: 1500,
      slidesPerView: 4,
      spaceBetween: 30,
      autoplay: {
        delay: 7000,
      },
      observer: true,
      observeParents: true,
      navigation: {
        clickable: !0,
        nextEl: ".our-stories .swiper-next",
        prevEl: ".our-stories .swiper-prev",
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        576: {
          slidesPerView: 1,
          spaceBetween: 15,
        },
      },
    }
  );
  var relatedBlogsSlide = new Swiper(
    ".related-blogs .swiper-container",
    {
      speed: 1500,
      slidesPerView: 4,
      spaceBetween: 30,
      autoplay: {
        delay: 7000,
      },
      observer: true,
      observeParents: true,
      navigation: {
        clickable: !0,
        nextEl: ".related-blogs .swiper-next",
        prevEl: ".related-blogs .swiper-prev",
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        576: {
          slidesPerView: 1,
          spaceBetween: 15,
        },
      },
    }
  );


  var testimonialsSlide = new Swiper(
    ".home-testimonials .swiper-container",
    {
      speed: 1500,
      slidesPerView: 3,
      spaceBetween: 30,
      autoplay: {
        delay: 7000,
      },
      observer: true,
      observeParents: true,
      navigation: {
        clickable: !0,
        nextEl: ".home-testimonials .swiper-next",
        prevEl: ".home-testimonials .swiper-prev",
      },
      breakpoints: {
        992: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 1,
          spaceBetween: 15,
        },
      },
    }
  );

  var ourServicesSlide = new Swiper(
    ".our-services .swiper-container",
    {
      speed: 1500,
      slidesPerView: 3,
      spaceBetween: 50,
      autoplay: {
        delay: 7000,
      },
      observer: true,
      observeParents: true,
      navigation: {
        clickable: !0,
        nextEl: ".our-services .swiper-next",
        prevEl: ".our-services .swiper-prev",
      },
      breakpoints: {
        992: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 1,
          spaceBetween: 15,
        },
      },
    }
  );

  var theNaturallySlide = new Swiper(
    ".the-naturally .swiper-container",
    {
      speed: 1500,
      slidesPerView: 1,
      spaceBetween: 20,
      autoplay: {
        delay: 7000,
      },
      observer: true,
      observeParents: true,
      navigation: {
        clickable: !0,
        nextEl: ".the-naturally .swiper-next",
        prevEl: ".the-naturally .swiper-prev",
      },
    }
  );


  $(".gallery-slider .swiper-container").each(function (index, element) {
    var $this = $(this);
    $this.addClass("tri-instance-" + index);
    $this
      .parents(".gallery-slider")
      .find(".swiper-prev")
      .addClass("btn-prev-" + index);
    $this
      .parents(".gallery-slider")
      .find(".swiper-next")
      .addClass("btn-next-" + index);
    $this
      .parents(".gallery-slider")
      .find(".swiper-pagination")
      .addClass("swiper-pagination-" + index);
    var swiper = new Swiper(".tri-instance-" + index, {
      speed: 1500,
      slidesPerView: 4,
      spaceBetween: -10,
      centeredSlides: true,
      loop: true,
      loopedSlides: 4,
      autoplay: {
        delay: 7000,
      },
      observer: true,
      observeParents: true,
      breakpoints: {
        992: {
          slidesPerView: 2,
          // spaceBetween: 20,
        },
      },
      navigation: {
        nextEl: ".btn-next-" + index,
        prevEl: ".btn-prev-" + index,
      },

    });
  });
}

function Headers() {
  $(document).on("click", ".toggle-btn", function () {
    $(this).toggleClass("active");
    $(".mobile-nav-inner").toggleClass("active");
    $(".header .overlay").toggleClass("active");
    $(".header").toggleClass("header-1");
    $("body").toggleClass("overflow-hidden");
  });
  $(document).on("click", ".header .overlay", function () {
    $(this).removeClass("active");
    $(".mobile-nav-inner").removeClass("active");
    $(".toggle-btn").removeClass("active");
    if($(".hero-banner,.banner-subpage").length){
      $(".header").addClass("header-1");
    }
    $("body").toggleClass("overflow-hidden");

  });
  $(document).on("click", ".search-toggle", function () {
    $(this).toggleClass("active");
    $(".searchbox").toggleClass("active");
  });
  var sb = $(".search");
  $(document).mouseup(function (e) {
    if (!sb.is(e.target) && sb.has(e.target).length === 0) {
      sb.find(".searchbox").removeClass("active");
    }
  });
}
//mapping
function mappings() {
  if ($(".header").length) {
    var moveNavLeft = new MappingListener({
      selector: ".header .menu-left",
      mobileWrapper: ".mobile-nav-inner",
      mobileMethod: "appendTo",
      desktopWrapper: ".header .logo",
      desktopMethod: "insertBefore",
      breakpoint: 1280,
    }).watch();
    var moveNavright = new MappingListener({
      selector: ".header .menu-right",
      mobileWrapper: ".mobile-nav-inner",
      mobileMethod: "appendTo",
      desktopWrapper: ".header .logo",
      desktopMethod: "insertAfter",
      breakpoint: 1280,
    }).watch();
  }
}
function accordion() {
  if ($(".accordions").length) {
    $(".accordion-item.active").find(".accordion-content").show();
    $(".accordion-heading").on("click", function () {
      if (!$(this).parent().is(".active")) {
        $(this)
          .parent()
          .toggleClass("active")
          .children(".accordion-content")
          .slideToggle(500)
          .parent()
          .siblings(".active")
          .removeClass("active")
          .children(".accordion-content")
          .slideToggle(500);
      } else {
        $(this).parent().toggleClass("active");
        $(this).next().slideToggle(500);
      }
    });
  }
}
function jarallax() {
  $(".jarallax").jarallax({
    speed: 0.2,
    disableParallax: / iPad | iPhone | iPod | Android /,
    disableVideo: / iPad | iPhone | iPod | Android /,
  });
}

function myTabs() {
  $(".my-tabs").each(function () {
    var $this = $(this);
    $this.find(".tabs-nav li:first").addClass("active");
    $this.find(".tab-content:first").show();
    $this.find(".tabs-nav li").click(function () {
      var corresponding = $(this).data("tab");
      $this.find(".tab-content").hide();
      $this.find(".tab-content." + corresponding).show();
      $this.find(".tabs-nav li").removeClass("active");
      $(this).addClass("active");
      $(".slick-container").slick("setPosition", 0);
    });
  });
}
function selectUi() {
  $(".dropdown").on("click", ".dropdown-select", function () {
    if ($(this).parents(".dropdown").hasClass("open")) {
      $(this).parents(".dropdown").removeClass("open");
      $(this).siblings(".dropdown-list").hide();
    } else {
      $(".dropdown").removeClass("open");
      $(this).parents(".dropdown").addClass("open");
      $(".dropdown-list").hide();
      $(this).siblings(".dropdown-list").show();
    }
  });
  var allOptions = $(".dropdown-list").children(".dropdown-item");
  $(".dropdown-list").on("click", ".dropdown-item", function () {
    allOptions.removeClass("selected");
    $(this).addClass("selected");
    $(this)
      .parents(".dropdown")
      .find(".dropdown-selected")
      .css("color", "#212429")
      .html($(this).html());

    $(this).parents(".dropdown-list").toggle();
    $(this).parents(".dropdown").toggleClass("open");
    $("input#inputInit").val($(this).data("val"));
  });
  var $menu = $(".dropdown");

  $(document).mouseup(function (e) {
    if (!$menu.is(e.target) && $menu.has(e.target).length === 0) {
      $menu.removeClass("open");
      $menu.find(".dropdown-list").hide();
    }
  });
}

function checkWidth() {
  var $window = $(window);
  var windowsize = $window.width();
  if (windowsize >= 768) {
    $(".sidebar-inner").removeAttr("style");
  }
  if (windowsize < 768) {
    $(".timeline-section .swiper-wrapper").removeAttr("style");
  }
  if (windowsize >= 1280) {
    $(".header").find(".nav-sub").removeAttr("style");
    $(".header").find(".nav-child").removeAttr("style");
  }
  if (windowsize >= 1280) {
    $(".back-drop").removeClass("active");
    $(
      ".header .menu-panel,.has-dropdown,.icon-dropdown,.icon-dropdown-2,.has-child,.toggle-btn"
    ).removeClass("active");
    $(".has-child:first-child").addClass("active");
    $(".has-child:first-child .nav-child").addClass("is-hover");
  }

  if ($(".hero-banner,.banner-subpage").length) {
    var HH = $(".header").height();
    $(".header").addClass("header-1");
    $(".hero-banner,.banner-subpage").addClass("change-position");
  }
  setTimeout(function () {
    $(".btn-position").each(function () {
      var imgHeight = $(this).find(".box-img").outerHeight();
      var btnHeight = $(this).find(".swiper-next").outerHeight();
      $(this)
        .find(".swiper-next,.swiper-prev")
        .css("top", imgHeight / 2 - btnHeight / 2);
    });
  }, 100);
}
function replaceSvg() {
  $("img.svg").each(function () {
    var $img = $(this);
    var imgID = $img.attr("id");
    var imgClass = $img.attr("class");
    var imgURL = $img.attr("src");
    $.get(
      imgURL,
      function (data) {
        // Get the SVG tag, ignore the rest
        var $svg = $(data).find("svg");

        // Add replaced image's ID to the new SVG
        if (typeof imgID !== "undefined") {
          $svg = $svg.attr("id", imgID);
        }
        // Add replaced image's classes to the new SVG
        if (typeof imgClass !== "undefined") {
          $svg = $svg.attr("class", imgClass + " replaced-svg");
        }

        // Remove any invalid XML tags as per http://validator.w3.org
        $svg = $svg.removeAttr("xmlns:a");

        // Replace image with new SVG
        $img.replaceWith($svg);
      },
      "xml"
    );
  });
}

function adjustProductAmount() {
  $(".plus").on("click", function () {
    $(this)
      .parents(".choose-number")
      .find(".input")
      .val(+$(this).parents(".choose-number").find(".input").val() + 1);
    $(".woocommerce-cart-form .update-cart.btn").removeAttr("disabled");
  });
  $(".minus").click(function () {
    if ($(this).parents(".choose-number").find(".input").val() > 1) {
      if ($(this).parents(".choose-number").find(".input").val() > 1)
        $(this)
          .parents(".choose-number")
          .find(".input")
          .val(+$(this).parents(".choose-number").find(".input").val() - 1);
    }
  });
}
function fixedNav() {
  var nav = $(".header");
  if (nav.length) {
    var offsetTop = nav.offset().top,
      TH = $(".header").height(),
      headerHeight = nav.height(),
      injectSpace = $("<div />", {
        height: headerHeight,
      }).insertAfter(".header");
    injectSpace.hide();
    $(window).on("load scroll resize", function () {
      if ($(window).scrollTop() > offsetTop) {
        nav.addClass("fixed-hide");
        injectSpace.show();
      } else {
        nav.removeClass("fixed-hide");
        injectSpace.hide();
      }

      if ($(window).scrollTop() > 130) {
        nav.addClass("fixed-show");
      } else {
        nav.removeClass("fixed-show");
      }
    });
  }
}
function sidebarDropdown() {
  $(".sidebar .item-content").slideUp(200);
  $(document).on("click", ".sidebar .item-toggle", function () {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this).next(".item-content").slideUp(200);
    } else {
      $(".sidebar .item-toggle").removeClass("active");
      $(this).addClass("active");
      $(".item-content").slideUp(200);
      $(this).next(".item-content").slideDown(200);
    }
  });
  $(document).on("click", ".sidebar-toggle", function () {
    $(this).toggleClass("active");
    $(".sidebar-inner").slideToggle();
  });
}
function countUp() {
  if ($(".statistics").length) {
    var options = {
      useEasing: true,
      useGrouping: true,
      separator: ",",
      decimal: ".",
      prefix: "",
      suffix: "",
    };
    var counts = [];
    $(".counter-1").each(function () {
      var num = $(this).attr("data-count"); //end count
      var nuen = $(this).text();
      if (nuen === "") {
        nuen = 0;
      }

      counts.push(new CountUp(this, nuen, num, 0, 3, options));
    });
    if ($(".statistics-1").length) {
      var waypoint1 = new Waypoint({
        element: document.getElementsByClassName("statistics-1"),
        handler: function (direction) {
          if (direction == "up") {
            for (var i = 0; i < counts.length; i++) {
              counts[i].reset();
            }
          } else {
            for (var i = 0; i < counts.length; i++) {
              counts[i].start();
            }
          }
        },
        offset: "80%",
      });
    }
  }
}
$(window).resize(checkWidth).trigger("resize");
$(document).ready(function () {
  App.Init();
  InitSlider();
  replaceSvg();
  Headers();
  selectUi();
  mappings()
  fixedNav();
  adjustProductAmount();
  accordion();
  sidebarDropdown();
  countUp();
  jarallax();
  myTabs();
  checkWidth();
  $( ".input-date input" ).datepicker();
  $("[data-fancybox]").fancybox({
    closeExisting: true,
    loop: true,
    touch: false,
    afterLoad: function () {
      $(".slider-1").slick("setPosition", 0);
    },
  });
  $('[data-fancybox="images"]').fancybox({
    baseClass: "myFancyBox",
    thumbs: {
      autoStart: true,
      axis: "x",
    },
  });
  $(".more-info-btn").on('click', function(){
    $(this).parents(".gallery-details").find(".box-content").addClass('show')
    $(this).parents(".inner").fadeOut()
  })
  $(".gallery-details .remove").on('click', function(){
    $(this).parents(".box-content").removeClass('show')
    $(this).parents(".gallery-details").find(".inner").fadeIn()
  })
});
